import { serverRequest } from './index';

export const chainInfo = {
  ethereum: { img: 'ethereum.png' },
  rinkeby: { img: 'ethereum.png' },
  palm: { img: 'palm.png' },
  'palm-test': { img: 'palm.png' },
};

export const getChainDetails = async ({ chainId = 'mainnet' }) => {
  let chainDetails = { chain: `${chainId}`, label: 'Unknown' };
  try {
    chainDetails = await serverRequest(`chains/${chainId}/details`);
  } catch (e) {
    console.warn(`Failed to get chain details for: ${chainId} (${e.message})`);
    if (e.status !== 404) {
      throw e;
    }
  }
  return chainDetails;
};
